import { DateCell } from 'components/DataTableTest'

export default ({ t, locales, showInterval, creditCols }) => ([
	{
		caption: t('common.dates.day'),
		dataField: 'dateTime',
		cellRender: DateCell({ locales }),
		groupCellRender: DateCell({ locales })
	}, { ...showInterval && {
		caption: t('common.fields.time'),
		dataField: 'interval'
	} }, {
		caption: t('common.fields.total_price'),
		dataField: 'total',
		localFormat: { type: 'float' },
		summary: {
			summaryType: 'sum',
			name: 'totalPrice'
		}
	}, {
		caption: t('statistic_section.strings.customers'),
		dataField: 'billCount',
		summary: {
			summaryType: 'sum',
			name: 'billCount'
		}
	}, {
		caption: `${t('common.fields.total_price')}/${t('statistic_section.strings.customers')}`,
		dataField: 'totalK',
		localFormat: { type: 'float' },
		summary: {
			calculateCustomSummary: options => {
				const { name, summaryProcess } = options
				if(name === 'totalPerCustomers') {
					if(summaryProcess === 'finalize') {
						const totalSum = options?.component?.getTotalSummaryValue?.('totalPrice')
						const totalBills = options?.component?.getTotalSummaryValue?.('billCount')
						if(totalSum && totalBills) {
							options.totalValue = totalSum / totalBills
						}
					}
				}
			},
			summaryType: 'custom',
			name: 'totalPerCustomers'
		}
	}, {
		caption: t('statistic_section.strings.credit_customer'),
		dataField: 'creditClient',
		localFormat: { type: 'float' },
		summary: {
			summaryType: 'sum'
		},
		visible: !!creditCols
	}, {
		caption: `${t('statistic_section.strings.customers')} KK`,
		dataField: 'creditClientCount',
		summary: {
			summaryType: 'sum'
		},
		visible: !!creditCols
	}, {
		caption: `KK/${t('statistic_section.strings.customers')} KK`,
		dataField: 'creditClientTotal',
		localFormat: { type: 'float' },
		summary: {
			summaryType: 'sum'
		},
		visible: !!creditCols
	}
])
